import React, { useEffect, useState } from 'react'
import { getUser, getUsers } from '../../../api'
import { JsonUser, User } from '../../../models'
import { getAuthUser, Roles, userHasRole } from '../../../helpers'
import defineAbilityFor from '../defineAbility'

interface FilterProps {
    updateFilters: (filterName: string, newValue: string, shouldDelete?: boolean) => void
}

export const SupplierFilters = (props: FilterProps) => {
    const { updateFilters } = props

    const ability = defineAbilityFor(getAuthUser())
    const currentUser = getAuthUser().id.toString()

    const canFilter = ability.can('Filter', 'SupplierRecovery')

    const [currentUserData, setCurrentUserData] = useState<User>()
    const [Users, setUsers] = useState<User[]>([])

    useEffect(() => {
        const promises = []

        promises.push(
            getUser(currentUser).then((json) => {
                if (json.data) {
                    setCurrentUserData(json.data)
                }
            })
        )

        if (canFilter) {
            promises.push(
                getUsers().then((json) => {
                    const Users = json.data
                        .map((user: JsonUser) => new User(user))
                        .filter(
                            (user: User) =>
                                userHasRole(user, Roles.Recovery) ||
                                userHasRole(user, Roles.CollectionAgent)
                        )
                    setUsers(Users)
                })
            )
        }

        Promise.allSettled(promises)
    }, [currentUser, canFilter])

    return (
        <div className="row g-2">
            <div className="col-lg-4 col-xl-3">
                <label htmlFor="assignedUserFilter" className="form-label mb-1">
                    Assigned to
                </label>
                <select
                    className="form-select form-select-sm"
                    id="assignedUserFilter"
                    onChange={(e) => {
                        const selectedUserId = e.target.value ?? ''
                        updateFilters(
                            'assigned_user_id',
                            selectedUserId,
                            selectedUserId === '-1'
                        )
                    }}
                >
                    <option value={-1}>All</option>
                    {canFilter
                        ? Users.map((user: User) => (
                              <option key={user.id} value={user.id}>
                                  {user.name}
                              </option>
                          ))
                        : currentUserData && (
                              <option value={currentUserData.id}>
                                  {currentUserData.name}
                              </option>
                          )}
                </select>
            </div>
        </div>
    )
}
